import React, { useMemo, useState } from 'react';
import { Dropdown, Form } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

// Searchable multi-select with checkboxes. options: [{ value, label }]; selected: array of values.
const ExpenseMultiSelect = ({ id, label, options, selected, onChange, searchPlaceholder }) => {
    const { t } = useTranslation();
    const [query, setQuery] = useState('');
    const q = query.trim().toLowerCase();
    const shown = useMemo(() => options.filter((o) => !q || o.label.toLowerCase().includes(q)), [options, q]);
    const toggle = (value) => onChange(selected.includes(value) ? selected.filter((v) => v !== value) : [...selected, value]);

    return (
        <Dropdown autoClose="outside" className="expense-multiselect" onToggle={(open) => { if (!open) setQuery(''); }}>
            <Dropdown.Toggle size="sm" variant={selected.length ? 'primary' : 'outline-secondary'} id={id} data-testid={`${id}-toggle`}>
                {label}{selected.length ? ` (${selected.length})` : ''}
            </Dropdown.Toggle>
            <Dropdown.Menu className="p-2 expense-multiselect-menu">
                <Form.Control size="sm" type="search" className="mb-2" value={query} aria-label={searchPlaceholder}
                    placeholder={searchPlaceholder} onChange={(e) => setQuery(e.target.value)} />
                <div className="expense-multiselect-list" role="listbox" aria-multiselectable="true" aria-label={label}>
                    {shown.map((o) => (
                        <Form.Check key={o.value} type="checkbox" id={`${id}-${o.value}`} className="expense-multiselect-option"
                            label={o.label} checked={selected.includes(o.value)} onChange={() => toggle(o.value)} />
                    ))}
                    {shown.length === 0 && <div className="text-muted small px-1">{t('expenses.filters.noOptions')}</div>}
                </div>
                {selected.length > 0 && (
                    <button type="button" className="btn btn-link btn-sm p-0 mt-2" onClick={() => onChange([])}>{t('expenses.filters.clearSelection')}</button>
                )}
            </Dropdown.Menu>
        </Dropdown>
    );
};

export default ExpenseMultiSelect;
